import type { BannerItem } from "@/types/services/public/apis/Banners";

export type BannerLink = {
  href: string;
  isExternal: boolean;
};

export function getBannerLink(banner: BannerItem): BannerLink | null {
  const value = banner.action.value?.trim();

  if (banner.action.type === "none" || !value) return null;

  if (banner.action.type === "route") {
    const href = value.startsWith("/") ? value : `/${value}`;

    return href.startsWith("//") ? null : { href, isExternal: false };
  }

  return /^https?:\/\//i.test(value) ? { href: value, isExternal: true } : null;
}
